import type { PayloadAction } from '@reduxjs/toolkit';

import { WritableAutoConfiguratorState } from '../slice';
import { revalidateFieldValuePreservingParseErrors } from '../validation/apply-validation';

type ClearCalculationResultPayload = {
  lineItemUuid: string;
};

export function clearCalculationResults(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<ClearCalculationResultPayload>,
) {
  const { lineItemUuid } = action.payload;
  const lineItem = state.lineItems[lineItemUuid];

  if (!lineItem) {
    return;
  }

  delete state.calculationErrorsByLineItemUuid[lineItemUuid];
  lineItem.calculatedData = null;

  for (const qbUuid of lineItem.quantityBreakUuids) {
    const qb = state.quantityBreaks[qbUuid];
    if (qb) {
      qb.calculatedData = null;

      /**
       * @NOTE(shawk): re-validate quantity field to clear out any errors that
       * were present due to calculation results
       */
      revalidateFieldValuePreservingParseErrors(
        state,
        { model: 'quantityBreak', key: 'quantity' },
        { model: 'quantityBreak', key: 'quantity', uuid: qbUuid },
      );
    }
  }
}
